import { toast } from "sonner";

export type CertificateStatus = {
  status: "valid" | "expiring" | "expired";
  not_after: string;
  days_remaining: number;
};

const CERTIFICATE_TOAST_DURATION_MS = 15000;

function formatExpiryMessage(daysRemaining: number) {
  if (daysRemaining === 0) return "O certificado digital expira hoje";
  if (daysRemaining === 1) return "O certificado digital expira em 1 dia";
  return `O certificado digital expira em ${daysRemaining} dias`;
}

export function showCertificateToast(certificate: CertificateStatus) {
  const expiryDate = new Date(certificate.not_after).toLocaleDateString(
    "pt-BR"
  );
  const options = { duration: CERTIFICATE_TOAST_DURATION_MS };

  if (certificate.status === "expired") {
    toast.error("Certificado digital expirado", {
      ...options,
      description: `O certificado venceu em ${expiryDate}. As assinaturas dos PDFs publicados não são válidas até a renovação. Avise a GETI.`,
    });
  } else if (certificate.status === "expiring") {
    toast.warning(formatExpiryMessage(certificate.days_remaining), {
      ...options,
      description: `Validade até ${expiryDate}. Avise a GETI para solicitar a renovação.`,
    });
  }
}
